<template>
  <span>
      <div v-show="isSure">
        <a v-on:click="isSure = !isSure" class="btn cursor-pointer">
          {{ buttonname }} <i aria-hidden="true" class="material-icons text-sm align-middle">{{buttonicon}}</i>
        </a>
      </div>
      <div v-if="!isSure" class="flex flex-col justify-center items-center bg-red-600 text-white w-full h-full p-3 absolute top-0 left-0 text-sm z-50 text-center" v-click-outside="onClickOutside">
          {{confirmtext}} <br>
          <template v-if="thelink">
            <a :href="thelink" class="btn text-sm bg-gray-100 text-red-700 commitbutton mt-2 rounded px-3 py-1 hover:text-white hover:bg-red-700"><i aria-hidden="true" class="material-icons align-middle text-xl">check</i>{{ confirmbutton }}</a>
          </template>
          <template v-if="routeparam">
            <a v-on:click="putItem" type="submit" class="btn text-sm bg-gray-100 text-red-700 commitbutton mt-1 rounded px-3 py-1 hover:text-white hover:bg-red-700"><i aria-hidden="true" class="material-icons align-middle text-xl">check</i>{{ confirmbutton }}</a>
          </template>
          <a v-on:click="onClickOutside" class="absolute top-0 right-0 text-white cursor-pointer mr-1 mt-1"><i aria-hidden="true" class="material-icons text-xs">cancel</i>Close</a>
      </div>
    </span>
</template>

<script>
import vClickOutside from 'v-click-outside'
import axios from 'axios'


  export default {

        props: {
            content: '',
            route:'',
            routeparam:'',
            thelink:'',
            buttontarget: {
              default: '_self'
            },
            confirmtext: {
              default: 'Are You Sure?',
            },
            confirmbutton: {
              default: 'Yes, I am sure',
            },
            buttonname: {
              default: 'Change',
            },
            buttonicon: {
              default: 'edit',
            },
            buttonsize: {
              default: 'text-xs',
            },
        },

        data() {
          return {
            isHidden: true,
            isSure: true,
            success: false,
            loaded: true,
            value: true,
          }
        },
        
        directives: {
          clickOutside: vClickOutside.directive
        },
        
        methods: {
          onClickOutside (event) {
              this.isSure = !this.isSure
          },
          
          formfocus() {
              document.getElementById("groupName").focus();
          },
          mounted(){
            this.formfocus()
          },

          putItem: function (event) {
            $( ".commitbutton").addClass( "loading" );
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              axios.put(this.route,
                { [this.routeparam]: this.value }
              )
              .then(function (response) {
                  console.log('This Was Clicked');
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
